import styled from "styled-components";
import { device } from "../../styles/devices";

export const AboutContainer = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    padding: 0 20px;
`;

export const AboutSection = styled.section`
    padding: 5rem 0 2rem;
    h2 {
        font-size: 2.5rem;
        line-height: 3rem;
        color: var(--color-title);
        margin-bottom: 0.5rem;
        text-align: center;

        @media ${device.tabletLarge}{
            font-size: 2.5rem;
            line-height: 3rem;
        }

        @media ${device.tablet}{
            font-size: 2rem;
            line-height: 2.5rem;
        }

        @media ${device.mobile}{
            text-align: initial;
        }
    }

   & > div > p {
        font-size: 1rem;
        font-weight: var(--font-normal);
        text-align: center;
        color: var(--color-text);

        @media ${device.mobile}{
            text-align: initial;
        }
    }
`;
export const AboutGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    column-gap: 4rem;
    margin-top: 3rem;

     @media ${device.tabletLarge}{
        grid-template-columns: repeat(1, 1fr);
        row-gap: 2.5rem;
        align-items: initial;
    }

     @media ${device.mobile}{
        row-gap: 2rem;
        margin-top: 2rem;
    }

    div {
         @media ${device.tabletLarge}{
            text-align: center;
        }

         @media ${device.mobile}{
            text-align: initial;
        }
        & > p {
            margin-bottom: 2rem;

            font-size: 1rem;
            font-weight: var(--font-normal);
            line-height: 1.5rem;
            color: var(--color-text);

            
             @media ${device.tabletLarge}{
                max-width: 650px;
                width: 100%;

                margin: 0 auto 2rem;
            }
        }
        
        & > a {
            padding: 1rem 2rem;
            border-radius: var(--button-radius);
            background-color: var(--color-black);
            color: var(--color-white);
            font-weight: var(--font-medium);
            font-size: 1rem;
            display: inline-block;
            transition: .3s ease-in;
            box-shadow: 0 1px 8px rgba(0,0,0,0.15);

            &:hover{
                background-color: var(--color-black-hover);
            }

            i {
                font-size: 1.1rem;
                margin-left: .5rem;
                display: inline-block;
            }
        }

    }
`;
